import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import React from 'react';
import styled from 'styled-components/macro';
import { iconButtonStyles } from '../../common/elements/Button';
import { fontSize, fontWeight, lineHeight, space } from '../../../theme/tokens';
import { DeleteButton } from '../../auth/elements/Auth.js';

export const UserPersonalContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  min-width: 0;
`;

export const EditButton = styled.button`
  ${iconButtonStyles}
`;

export const EditIcon = (props) => {
  return <EditOutlinedIcon {...props} style={{ fontSize: fontSize.xl }} />;
};

export const TargetList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  margin: 0;
  padding-left: ${space[5]};
  color: ${({ theme }) => theme.headerColour};
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.semibold};
  line-height: ${lineHeight.normal};
  overflow-wrap: anywhere;
`;

export const PlainList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${space[2]};
  margin: 0;
  padding: 0;
  list-style: none;
  font-size: ${fontSize.md};
  font-weight: ${fontWeight.semibold};
  color: ${({ theme }) => theme.headerColour};
`;

export const TargetLi = styled.li``;

export const UserManagementControls = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${space[2]};
`;

export const UserManagementButton = styled(DeleteButton)`
  margin: 0;
`;

export * from '../../common/elements/Form';
export * from '../../common/elements/Staff';
